/**
 * Sudo Banner
 *
 * Displayed when an admin is impersonating a viewer.
 * Shows the target user's name and provides an exit button.
 */

import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import { Close as CloseIcon, Visibility as VisibilityIcon } from '@mui/icons-material';
import { useSudo } from '../hooks/useSudo';

export function SudoBanner() {
  const { sudoUser, isSudoMode, stopSudo } = useSudo();
  const navigate = useNavigate();

  if (!isSudoMode || !sudoUser) {
    return null;
  }

  const displayEmail = sudoUser.externalUserId?.replace(/^embed-/, '') || '';

  const handleExit = () => {
    stopSudo();
    navigate('/users');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1,
        bgcolor: '#fff3e0',
        borderBottom: '2px solid #ff9800',
        zIndex: 1100,
      }}
    >
      <VisibilityIcon sx={{ color: '#e65100', fontSize: '1.25rem' }} />
      <Typography variant="body2" sx={{ flex: 1, color: '#e65100', fontWeight: 500 }}>
        Viewing as <strong>{sudoUser.firstName} {sudoUser.lastName}</strong>
        {displayEmail && ` (${displayEmail})`}
      </Typography>
      <Button
        size="small"
        variant="outlined"
        startIcon={<CloseIcon />}
        onClick={handleExit}
        sx={{
          color: '#e65100',
          borderColor: '#e65100',
          '&:hover': {
            borderColor: '#bf360c',
            bgcolor: '#ffe0b2',
          },
        }}
      >
        Exit
      </Button>
    </Box>
  );
}
